import {
  MonthViewTheme,
  styles,
  variants,
  multiVariantStyles
} from '#PRIVATE_MonthView/themes/MonthViewStyles.css';

const MonthViewRedwoodTheme: MonthViewTheme = {
  multiVariantStyles,
  variants,
  styles
};

export { MonthViewRedwoodTheme };
